export const calculateSuperbetPossibleWin = (stake, price, currencyConfig) => {
  if (!stake) return null;

  const rounding = Math.abs(currencyConfig.rounding);
  const amount = stake * price;

  return parseFloat(amount.toFixed(rounding));
}